// To config available list views

const availableListViews = {
  "table": true,
  "grid": true
}

export default availableListViews;